module.exports = __webpack_public_path__ + "img/kund1.cd818bc3.jpg";